module.exports = __webpack_public_path__ + "static/media/DIGITALIS-EXTIME-LOGOTYPE-2021-13.db1e00cf.png";